module.exports = __webpack_public_path__ + "static/media/33.95fd999f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/33.jpg
// module id = 566
// module chunks = 0